import CommitteePublicationNewContent from 'components/Dashboard/CommitteePublication/CommitteePublicationNewContent';
import ConsultationNewContent from 'components/Dashboard/ConsultationsSection/ConsultationNewContent';
import KeyUpdateNewContent from 'components/Dashboard/KeyUpdates/KeyUpdateNewContent';
import LegislationNewContent from 'components/Dashboard/Legislation/LegislationNewContent';
import LibraryMaterialMainContent from 'components/Dashboard/LibraryMaterial/LibraryMaterialMainContent';
import ParliamentaryNewContent from 'components/Dashboard/ParliamentaryRecord/ParliamentaryNewContent';
import RegulationsDocketPage from 'components/Dashboard/Regulations/RegulationsDocketPage';
import RegulationCommentContentPage from 'components/Dashboard/Regulations/RegulationCommentContentPage';
import RegulationDocumentContentPage from 'components/Dashboard/Regulations/RegulationDocumentContentPage';
import TweetItem from 'components/Dashboard/SocialMedia/TweetItem';
import ReportsInfluenceContent from 'components/Reports/ui/ReportsInfluenceComponent';
import CrmInteractionNewContent from 'components/Dashboard/Influence/CrmInteractions/CrmInteractionNewContent';
import GovernmentPublicationNewContent from 'components/Dashboard/GovernmentPublications/GovernmentPublicationNewContent';

const ContentBodyRenderer = (props) => {
  const { contentType, currentNew, contributionId, fallback = '', ...contentProps } = props;

  const sharedProps = {
    currentNew,
    contributionId,
    ...contentProps,
  };

  switch (contentType) {
    case 'Legislation':
      return <LegislationNewContent {...sharedProps} />;
    case 'ParliamentaryRecord':
    case 'HansardContent':
    case 'CountrySpecificParliamentaryRecord':
    case 'SeneddCommitteeTranscript':
    case 'Edm':
    case 'CongressionalRecord':
      return <ParliamentaryNewContent {...sharedProps} />;
    case 'LibraryArticle':
    case 'LibraryArticles':
    case 'LibraryMaterial':
      return <LibraryMaterialMainContent {...sharedProps} />;
    case 'KeyUpdate':
    case 'KeyUpdates':
    case 'HandPickedKeyUpdates':
      return <KeyUpdateNewContent {...sharedProps} />;
    case 'Consultation':
    case 'Consultations':
      return <ConsultationNewContent {...sharedProps} />;
    case 'UserContent':
      return <ReportsInfluenceContent {...sharedProps} />;
    case 'CommitteePublication':
    case 'CommitteePublications':
      return <CommitteePublicationNewContent {...sharedProps} />;
    case 'GovernmentPublication':
    case 'GovernmentPublications':
      return <GovernmentPublicationNewContent {...sharedProps} />;
    case 'Tweet':
      return (
        <TweetItem
          listRow={{
            listContext: { item: currentNew },
            display: { notShowShare: true },
            external: { noTweetActions: true },
          }}
        />
      );
    case 'Regulations':
      return <RegulationsDocketPage {...sharedProps} />;
    case 'RegulationDocumentComment':
    case 'RegulationComments':
      return <RegulationCommentContentPage {...sharedProps} />;
    case 'RegulationDocument':
    case 'RegulationDocuments':
      return <RegulationDocumentContentPage {...sharedProps} />;
    case 'CrmInteraction':
      return <CrmInteractionNewContent {...props} />;
    default:
      return fallback;
  }
};

export default ContentBodyRenderer;
